var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCelebration128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2275_8983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5547 44.7126V32.4156",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 44.7126V32.4156",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4463 44.7126V32.4156",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5582 22.5782C45.5141 24.7185 46.6708 26.349 47.0282 27.4697C47.5644 29.1507 47.093 30.5964 45.7028 31.6254C44.3126 32.6544 42.8707 32.7039 41.4135 31.6254C39.9564 30.5469 39.5618 29.1197 40.0881 27.4697C40.4389 26.3697 41.5956 24.7393 43.5582 22.5782Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0035 22.578C65.9594 24.7183 67.1161 26.3488 67.4735 27.4695C68.0097 29.1505 67.5383 30.5962 66.1481 31.6252C64.7579 32.6541 63.316 32.7037 61.8588 31.6252C60.4017 30.5466 60.0072 29.1194 60.5334 27.4695C60.8842 26.3695 62.0409 24.739 64.0035 22.578Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4498 22.5782C86.4057 24.7185 87.5624 26.349 87.9198 27.4697C88.456 29.1507 87.9846 30.5964 86.5944 31.6254C85.2042 32.6544 83.7623 32.7039 82.3051 31.6254C80.848 30.5469 80.4534 29.1197 80.9797 27.4697C81.3305 26.3697 82.4872 24.7393 84.4498 22.5782Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9608 43.483H107.039C109.756 43.483 111.958 45.6852 111.958 48.4018V102.508C111.958 105.225 109.756 107.427 107.039 107.427H20.9608C18.2442 107.427 16.042 105.225 16.042 102.508V48.4018C16.042 45.6852 18.2442 43.483 20.9608 43.483Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9608 43.483H107.039C109.756 43.483 111.958 45.6852 111.958 48.4018V65.6176H16.042V48.4018C16.042 45.6852 18.2442 43.483 20.9608 43.483Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2275_8983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCelebration128);
export default __webpack_public_path__ + "static/media/pictogramBeaconCelebration128.73af46cf5167d5b3d55afea43494b7ef.svg";
export { ForwardRef as ReactComponent };